import React from 'react'
import PbacResourceTypes from './ResourceTypes/index'
import { PageContextProvider } from 'pageContext'
import ApplicationRights from './AppRights'
import ApplicationRoleDefinitions from './RoleDefinitions'
import AppManagementRoles from './AppManagementRoles/AppManagementRoles'
import AppOwnedFieldTypes from './AppOwnedFieldTypes'

const PbacDefinitinos = ({
    subActiveTab,
    applicationId,
    resourceSystemModuleId,
    id,
    resourceId,
}) => {
    const renderContent = () => {
        if (subActiveTab === 'appRights') {
            return (
                <PageContextProvider key="RequestViewApplicationPbacDefinitionAppRights">
                    <ApplicationRights
                        applicationId={id}
                        resourceId={resourceId}
                        isPbacApplication={true}
                    />
                </PageContextProvider>
            )
        } else if (subActiveTab === 'roleDefinitions') {
            return (
                <PageContextProvider key="RequestViewApplicationPbacDefinitionRoleDefinitions">
                    <ApplicationRoleDefinitions
                        applicationId={applicationId}
                        resourceSystemModuleId={resourceSystemModuleId}
                    />
                </PageContextProvider>
            )
        } else if (subActiveTab === 'appManagementRoles') {
            return (
                <PageContextProvider key="RequestViewApplicationPbacDefinitionManagementRoles">
                    <AppManagementRoles applicationId={applicationId} />
                </PageContextProvider>
            )
        }
        if (subActiveTab === 'pbacResourceTypes') {
            return (
                <PageContextProvider key="RequestViewApplicationPbacDefinitionResourceTypes">
                    <PbacResourceTypes
                        applicationId={applicationId}
                        resourceSystemModuleId={resourceSystemModuleId}
                    />
                </PageContextProvider>
            )
        }
        if (subActiveTab === 'appOwnedFieldTypes') {
            return (
                <PageContextProvider key="RequestViewApplicationPbacDefinitionResourceTypes">
                    <AppOwnedFieldTypes
                        resourceSystemModuleId={resourceSystemModuleId}
                        applicationId={applicationId}
                    />
                </PageContextProvider>
            )
        }
        return <></>
    }
    return renderContent()
}

export default PbacDefinitinos
